/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Tip_Csv_TInputs */



/**
* | output |
* | --- |
* | "Import the paid registrations" |
*
* @param {Tournament_Wiz_Tip_Csv_TInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_tip_csv_t = /** @type {((inputs?: Tournament_Wiz_Tip_Csv_TInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Tip_Csv_TInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importez les inscriptions payées")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importe las inscripciones pagadas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Importe as inscrições pagas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa le iscrizioni pagate")
	return /** @type {LocalizedString} */ ("Import the paid registrations")
});